import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const UOM3 = ({ value, onChange, placeholder = "Select Unit", className = "control-Select mb-3", disabled }) => {
    return (
        <Select
            disabled={disabled}
            className={className}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            allowClear
        >
            <Option value="G">G</Option>
            <Option value="ML">ML</Option>
            <Option value="PIECE">PIECE</Option>
            <Option value="PORTION">PORTION</Option>
            <Option value="SERVING">SERVING</Option>
        </Select>
    );
};

export default UOM3;
